import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { versionInfo } from "../../../version-info";

import { LoginService } from "../shared";

import { LoadingBarService } from "@ngx-loading-bar/core";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  message;

  loginForm: FormGroup;

  loginRequest;

  buildVersion = versionInfo.version;

  constructor(
    private formBuilder: FormBuilder,
    private loadingBarService: LoadingBarService,
    private loginService: LoginService,
    private router: Router
  ) {
    this.loginForm = this.formBuilder.group({
      username: ["", [Validators.required]],
      password: ["", [Validators.required]]
    });
  }

  ngOnInit() {}

  login() {
    this.loadingBarService.stop();

    this.loadingBarService.start();

    if (this.loginRequest) {
      this.loginRequest.unsubscribe();
    }

    this.loginRequest = this.loginService.login(this.loginForm.value).subscribe(
      data => {
        this.loadingBarService.complete();
        let response = JSON.parse(JSON.stringify(data));

        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("expiresIn", response.data.expiresIn);
        localStorage.setItem("userId", response.data.userId);
        localStorage.setItem("userName", response.data.userName);
        localStorage.setItem("userMenu", JSON.stringify(response.data.menus));

        this.router.navigate(["/panel"]);
      },
      error => {
        let response = error;

        this.loadingBarService.complete();

        this.message = response.error.message;
      }
    );
  }
}
